// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Searchable dropdown — drop-in replacement for <select> ───────────── */
.ss {
  position: relative;
  display: inline-block;
  /* Default to content-sized with a sensible minimum.  In flex toolbars this
     lets multiple dropdowns sit side-by-side without forcing wrap.  Form
     groups that need full width should set width on .ss explicitly (e.g.
     via the className prop or a wrapping div). */
  width: auto;
  min-width: 160px;
  max-width: 100%;
  vertical-align: middle;
  font-family: inherit;
}
/* Helper class — apply when you DO want full container width
   (e.g. inside a form-group). */
.ss-full { width: 100%; min-width: 0; }

/* When dropped inside a form layout, fill the available column width so it
   matches the surrounding inputs.  These are the standard form-group
   wrappers used throughout the app. */
.fg .ss,
.form-group .ss,
.form-row .ss { width: 100%; min-width: 0; }

.ss-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 6px 10px;
  background: var(--n-0);
  border: 1px solid var(--n-300);
  border-radius: var(--radius-md);
  font-size: 12px;
  font-weight: 500;
  color: var(--n-900);
  cursor: pointer;
  transition: border-color var(--dur-base) ease, box-shadow var(--dur-base) ease;
  text-align: left;
  font-family: inherit;
  line-height: var(--lh-snug);
  min-height: 32px;
}
.ss-trigger:hover:not(:disabled) {
  border-color: var(--n-400);
}
.ss-trigger:focus,
.ss.is-open .ss-trigger {
  outline: none;
  border-color: var(--brand-500);
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.15);
}
.ss-trigger:disabled,
.ss.is-disabled .ss-trigger {
  background: var(--n-50);
  color: var(--n-400);
  cursor: not-allowed;
}

.ss-value {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ss-value.is-placeholder { color: var(--n-400); font-weight: 400; }

.ss-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  color: var(--n-500);
  font-size: 13px;
  line-height: var(--lh-tight);
  cursor: pointer;
  background: transparent;
}
.ss-clear:hover { background: var(--danger-100); color: var(--danger-600); }

.ss-caret {
  color: var(--n-500);
  font-size: 11px;
  transition: transform var(--dur-base) ease;
}
.ss.is-open .ss-caret { transform: rotate(180deg); color: var(--brand-500); }

/* Popover */
.ss-pop {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: var(--n-0);
  border: 1px solid var(--n-200);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  z-index: 40;
  overflow: hidden;
  animation: ssFadeIn var(--dur-fast) var(--ease-out);
}
@keyframes ssFadeIn {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Search — bordered, prominent box like the reference design */
.ss-search {
  padding: 10px 10px 8px;
  background: var(--n-0);
  border-bottom: 1px solid var(--n-100);
}
.ss-search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: var(--n-0);
  border: 1.5px solid var(--brand-300);
  border-radius: var(--radius-xl);
  transition: border-color var(--dur-fast) ease, box-shadow var(--dur-fast) ease;
}
.ss-search-box:focus-within {
  border-color: var(--brand-400);
  box-shadow: 0 0 0 3px var(--n-200);
}
.ss-search-icon {
  font-size: 14px;
  color: var(--n-400);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ss-search-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 13px;
  outline: none;
  color: var(--n-900);
  font-family: inherit;
}
.ss-search-input::placeholder { color: var(--n-400); }
.ss-search-clear {
  width: 22px;
  height: 22px;
  border: none;
  background: var(--n-100);
  border-radius: 50%;
  cursor: pointer;
  color: var(--n-500);
  font-size: 13px;
  line-height: var(--lh-tight);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ss-search-clear:hover { background: var(--danger-100); color: var(--danger-600); }

/* List */
.ss-list {
  max-height: 260px;
  overflow-y: auto;
  padding: 4px;
}
.ss-list::-webkit-scrollbar { width: 8px; }
.ss-list::-webkit-scrollbar-thumb { background: var(--n-300); border-radius: var(--radius-sm); }
.ss-list::-webkit-scrollbar-thumb:hover { background: var(--n-400); }

.ss-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: var(--radius-md);
  font-size: 13px;
  color: var(--n-900);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.ss-item.is-highlighted { background: var(--n-200); }
.ss-item.is-selected {
  background: var(--brand-50);
  color: var(--brand-500);
  font-weight: 600;
}
.ss-item-label {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ss-check {
  margin-left: 8px;
  color: var(--brand-500);
  font-weight: 700;
}

.ss-empty {
  padding: 22px 14px;
  text-align: center;
  color: var(--n-400);
  font-size: 12px;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/common/SearchableSelect.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,qBAAqB;EACrB;;;iDAG+C;EAC/C,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;AACA;gCACgC;AAChC,WAAW,WAAW,EAAE,YAAY,EAAE;;AAEtC;;sCAEsC;AACtC;;gBAEgB,WAAW,EAAE,YAAY,EAAE;;AAE3C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,8EAA8E;EAC9E,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,8CAA8C;AAChD;AACA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,2BAA2B,mBAAmB,EAAE,gBAAgB,EAAE;;AAElE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;AACzB;AACA,kBAAkB,6BAA6B,EAAE,wBAAwB,EAAE;;AAE3E;EACE,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;AACA,wBAAwB,yBAAyB,EAAE,uBAAuB,EAAE;;AAE5E,YAAY;AACZ;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,mDAAmD;AACrD;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,+DAA+D;AAC/D;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,+BAA+B;EAC/B,8EAA8E;AAChF;AACA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA,gCAAgC,mBAAmB,EAAE;AACrD;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,yBAAyB,6BAA6B,EAAE,wBAAwB,EAAE;;AAElF,SAAS;AACT;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA,8BAA8B,UAAU,EAAE;AAC1C,oCAAoC,wBAAwB,EAAE,+BAA+B,EAAE;AAC/F,0CAA0C,wBAAwB,EAAE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,0BAA0B,wBAAwB,EAAE;AACpD;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* ── Searchable dropdown — drop-in replacement for <select> ───────────── */\n.ss {\n  position: relative;\n  display: inline-block;\n  /* Default to content-sized with a sensible minimum.  In flex toolbars this\n     lets multiple dropdowns sit side-by-side without forcing wrap.  Form\n     groups that need full width should set width on .ss explicitly (e.g.\n     via the className prop or a wrapping div). */\n  width: auto;\n  min-width: 160px;\n  max-width: 100%;\n  vertical-align: middle;\n  font-family: inherit;\n}\n/* Helper class — apply when you DO want full container width\n   (e.g. inside a form-group). */\n.ss-full { width: 100%; min-width: 0; }\n\n/* When dropped inside a form layout, fill the available column width so it\n   matches the surrounding inputs.  These are the standard form-group\n   wrappers used throughout the app. */\n.fg .ss,\n.form-group .ss,\n.form-row .ss { width: 100%; min-width: 0; }\n\n.ss-trigger {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 6px 10px;\n  background: var(--n-0);\n  border: 1px solid var(--n-300);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--n-900);\n  cursor: pointer;\n  transition: border-color var(--dur-base) ease, box-shadow var(--dur-base) ease;\n  text-align: left;\n  font-family: inherit;\n  line-height: var(--lh-snug);\n  min-height: 32px;\n}\n.ss-trigger:hover:not(:disabled) {\n  border-color: var(--n-400);\n}\n.ss-trigger:focus,\n.ss.is-open .ss-trigger {\n  outline: none;\n  border-color: var(--brand-500);\n  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.15);\n}\n.ss-trigger:disabled,\n.ss.is-disabled .ss-trigger {\n  background: var(--n-50);\n  color: var(--n-400);\n  cursor: not-allowed;\n}\n\n.ss-value {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ss-value.is-placeholder { color: var(--n-400); font-weight: 400; }\n\n.ss-clear {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  color: var(--n-500);\n  font-size: 13px;\n  line-height: var(--lh-tight);\n  cursor: pointer;\n  background: transparent;\n}\n.ss-clear:hover { background: var(--danger-100); color: var(--danger-600); }\n\n.ss-caret {\n  color: var(--n-500);\n  font-size: 11px;\n  transition: transform var(--dur-base) ease;\n}\n.ss.is-open .ss-caret { transform: rotate(180deg); color: var(--brand-500); }\n\n/* Popover */\n.ss-pop {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: var(--n-0);\n  border: 1px solid var(--n-200);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-lg);\n  z-index: 40;\n  overflow: hidden;\n  animation: ssFadeIn var(--dur-fast) var(--ease-out);\n}\n@keyframes ssFadeIn {\n  from { opacity: 0; transform: translateY(-4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* Search — bordered, prominent box like the reference design */\n.ss-search {\n  padding: 10px 10px 8px;\n  background: var(--n-0);\n  border-bottom: 1px solid var(--n-100);\n}\n.ss-search-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  background: var(--n-0);\n  border: 1.5px solid var(--brand-300);\n  border-radius: var(--radius-xl);\n  transition: border-color var(--dur-fast) ease, box-shadow var(--dur-fast) ease;\n}\n.ss-search-box:focus-within {\n  border-color: var(--brand-400);\n  box-shadow: 0 0 0 3px var(--n-200);\n}\n.ss-search-icon {\n  font-size: 14px;\n  color: var(--n-400);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.ss-search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 13px;\n  outline: none;\n  color: var(--n-900);\n  font-family: inherit;\n}\n.ss-search-input::placeholder { color: var(--n-400); }\n.ss-search-clear {\n  width: 22px;\n  height: 22px;\n  border: none;\n  background: var(--n-100);\n  border-radius: 50%;\n  cursor: pointer;\n  color: var(--n-500);\n  font-size: 13px;\n  line-height: var(--lh-tight);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.ss-search-clear:hover { background: var(--danger-100); color: var(--danger-600); }\n\n/* List */\n.ss-list {\n  max-height: 260px;\n  overflow-y: auto;\n  padding: 4px;\n}\n.ss-list::-webkit-scrollbar { width: 8px; }\n.ss-list::-webkit-scrollbar-thumb { background: var(--n-300); border-radius: var(--radius-sm); }\n.ss-list::-webkit-scrollbar-thumb:hover { background: var(--n-400); }\n\n.ss-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  color: var(--n-900);\n  cursor: pointer;\n  user-select: none;\n}\n.ss-item.is-highlighted { background: var(--n-200); }\n.ss-item.is-selected {\n  background: var(--brand-50);\n  color: var(--brand-500);\n  font-weight: 600;\n}\n.ss-item-label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ss-check {\n  margin-left: 8px;\n  color: var(--brand-500);\n  font-weight: 700;\n}\n\n.ss-empty {\n  padding: 22px 14px;\n  text-align: center;\n  color: var(--n-400);\n  font-size: 12px;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
